// core stuff
import React from "react";
import { useRecoilState } from "recoil";
import { resendEmailVerification } from "../../../../api/users/getUser.js";
import { userAtom } from "../../atoms/userAtom.js";


function TopBannerEmailConfirmation() {
	const [user, setUser] = useRecoilState(userAtom)

	const onResendEmailVerification = () => {
		resendEmailVerification()
			.then((response) => {
				localStorage.setItem('emailConfirmationSent', true)
				setUser({
					...user,
					emailData: {
						...user.emailData,
						confirmationSent: localStorage.getItem('emailConfirmationSent'),
						confirmationSentNow: true
					}
				})
			})
			.catch((error) => {
				console.log("submit error: ", error);
			});
	};

	var element = (
		<div
			id="alert"
			className={(user.emailData.confirmationSentNow ? 'alert-success':'alert-secondary') 
				+ ' alert fade show text-center py-2'}
			role="alert">
			{!user.emailData.confirmationSent && !user.emailData.confirmationSentNow ?
			<>Email address is not validated. Please, <a onClick={onResendEmailVerification} className="alert-link">click here</a> to resend confirmation email.</> :
				user.emailData.confirmationSent && !user.emailData.confirmationSentNow ?
				<>Email address is not confirmed. Please, confirm your email address. If you didn't receive an email, You can <a onClick={onResendEmailVerification} className="alert-link">resend it.</a></> : 
					user.emailData.confirmationSent && user.emailData.confirmationSentNow ?
					<>Confirmation email sent! Please, check your email inbox.</> : '' 
			}
		</div>
		
	
	);

	return ( user.id && !user.emailData.emailConfirmed ? element : '');
}

export default TopBannerEmailConfirmation;
